import React from 'react';
import { DatePicker, CalendarNavigationItem, /*MultiViewCalendar, */Calendar } from "@progress/kendo-react-dateinputs";
import PropTypes from 'prop-types';
import { AppContext } from '../context/AppContext';
import { getLocaleDateString } from '../helpers';
import moment from 'moment'
import 'moment/locale/fr'
import localize from "../hoc/localize";
import weekData from "cldr-core/supplemental/weekData.json";
import frCaGregorian from "cldr-dates-full/main/fr/ca-gregorian.json";
import { LocalizationProvider, load, IntlProvider } from '@progress/kendo-react-intl';
load(
    weekData,
    frCaGregorian,
  );

// customizing the calendar so that we display MONTH+YEAR in the navigation column.
// otherwise, January always gets rendered as the year (e.g. "2019") instead of the 
// actual month name.

// can read more about it here:
// https://www.telerik.com/kendo-react-ui/components/dateinputs/calendar/custom-rendering/#toc-items-in-the-side-navigation

// normally when injecting a custom calendar into a Datepicker, you lose the ability to close the calendar by clicking outside of it.
// the folks at Telerik provided this solution which I am using in CustomCalendar.
// https://stackblitz.com/edit/react-tyssw6-h9emkd?file=app%2FcustomCalendar.js
class CustomCalendar extends React.Component {
    cal;
    componentDidMount() {
        if (this.cal) {
            Promise.resolve().then(() => {
                this.cal.element.focus({ preventScroll: true })
            });
        }
    }
    render() {

        return (
            <Calendar
                ref={(el) => this.cal = el}
                views={1}
                value={this.props.value}
                onChange={this.props.onChange}
                navigationItem={CustomNavigationItem}
            />
        );
    }
}

class CustomNavigationItem extends React.Component {
    state = {
        formattedDate: []
    }
    componentDidMount() {
        const date = this.props.value;
        this.setState({ formattedDate: moment(date).format("MMM YYYY") });
    }

    componentDidUpdate(prevState) {
        const date = this.props.value;
        if (this.state.formattedDate !== moment(date).format("MMM YYYY")) {
            this.setState({ formattedDate: moment(date).format("MMM YYYY") });
        }
    }

    render() {
        // get date object

        return (
            <CalendarNavigationItem {...this.props} >
                {this.state.formattedDate}
            </CalendarNavigationItem>
        );
    }
}



class DatePickerContainer extends React.Component {
    static propTypes = {
        handleClearDate: PropTypes.func,
        label: PropTypes.string,
        showLabel: PropTypes.bool,
        name: PropTypes.string.isRequired
    }

    constructor(props) {
        super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    handleFocus = function (event) {
        event.currentTarget.classList.add('k-state-focused');
    }

    handleBlur = function (event) {
        event.currentTarget.classList.remove('k-state-focused');
    }

    handleCloserClick = () => {

        this.props.handleClearDate(this.props.name);
    }

    componentDidMount() {
        moment.locale(this.props.uiLanguage)
    }
    componentDidUpdate(prevProps) {
        if (prevProps.uiLanguage !== this.props.uiLanguage) {
            moment.locale(this.props.uiLanguage)
        }
    }

    render() {
        // get user's language code
        const dateString = getLocaleDateString();

        return (
            <IntlProvider locale = {this.props.getLanguage()}>
                <LocalizationProvider language={this.props.getLanguage()}>
                        <React.Fragment>
                            <div className="dp-container" onFocus={this.handleFocus} onBlur={this.handleBlur} >
                                {this.props.showLabel && <label className="k-label">{this.props.label}</label>}
                                <span className="closer" onClick={this.handleCloserClick}>x</span>
                                <DatePicker formatPlaceholder={{ year: 'yyyy', month: 'm', day: 'd' }} calendar={CustomCalendar} format={dateString} {...this.props} />
                            </div>

                        </React.Fragment>
                </LocalizationProvider>
            </IntlProvider>
        );
    }

}
DatePickerContainer.contextType = AppContext;

export default localize(DatePickerContainer)


// WEBPACK FOOTER //
// ./src/components/DatePickerContainer.js